





























































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { storeRiwayat } from "@/store/modules/riwayat";
import CardDetailRiwayat from "@/components/pemeriksaan/riwayat/CardDetailRiwayat.vue";
import CardDetailIterObat from "@/components/pemeriksaan/riwayat/CardDetailIterObat.vue";
import { RiwayatBukaTarget, RiwayatDrawerRow } from "@/types/riwayat";
import { pemeriksaanRouteName } from "@/utils/unit";

@Component({
  components: {
    CardDetailRiwayat,
    CardDetailIterObat
  }
})
export default class CardListRiwayatPasien extends Vue {
  @Prop({ required: true }) rm: string;
  @Prop({ type: Boolean, default: false }) active: boolean;
  panel: number | null = null;

  get rows(): RiwayatDrawerRow[] {
    return storeRiwayat.rows;
  }
  get loadingList() {
    return storeRiwayat.loadingList;
  }
  get listError() {
    return storeRiwayat.listError;
  }
  get hasMore() {
    return storeRiwayat.hasMore;
  }
  get page() {
    return storeRiwayat.page;
  }

  @Watch("rm", { immediate: true })
  onRmChanged() {
    this.panel = null;
    this.ensureList();
  }

  @Watch("$route.params.register")
  onRegisterChanged() {
    this.panel = null;
    this.ensureList();
  }

  @Watch("active")
  onActiveChanged(val: boolean) {
    if (val) this.ensureList();
  }

  ensureList() {
    if (!this.active || !this.rm) return;

    storeRiwayat.ensureList(String(this.rm));
  }

  onIntersect(
    entries: IntersectionObserverEntry[],
    observer: IntersectionObserver,
    isIntersecting: boolean
  ) {
    if (isIntersecting) storeRiwayat.loadMore();
  }

  retryList() {
    if (storeRiwayat.page > 0) {
      storeRiwayat.loadMore();
    } else {
      this.ensureList();
    }
  }

  bukaRiwayat(buka: RiwayatBukaTarget) {
    const target = pemeriksaanRouteName(buka.unit, buka.unitAsal);
    if (
      buka.register === String(this.$route.params.register) &&
      target === this.$route.name
    ) {
      return;
    }
    this.$router.push({
      name: target,
      params: {
        register: buka.register,
        rm: String(this.rm)
      }
    });
  }
}
